/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.0.0
 */

import createSagaMiddleware from 'redux-saga';

const sagaMiddleware = createSagaMiddleware();

export default sagaMiddleware;
